var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "activity-tracker-tabs" }, [
    _c("div", { staticClass: "tabs-left" }, [
      _c("ul", { staticClass: "nav nav-tabs", attrs: { role: "tablist" } }, [
        _c(
          "li",
          {
            staticClass: "nav-item",
            class: { active: _vm.tabActiveName == "rationales" },
            attrs: { role: "presentation" },
          },
          [
            _c(
              "span",
              {
                staticClass: "nav-link",
                attrs: { role: "tab", "data-toggle": "tab" },
                on: {
                  click: function ($event) {
                    return _vm.tabClicked("rationales")
                  },
                },
              },
              [_vm._v("Rationale Reports (" + _vm._s(_vm.rationaleCount) + ")")]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }